<div class="md-form md-outline">
  <jhi-bary-icon *ngIf="icon" [icon]="icon" [faDirective]="FAR" class="suffix"></jhi-bary-icon>
  <textarea
    type="text"
    *ngIf="placeholder"
    [formControl]="control"
    [id]="id"
    [placeholder]="placeholder"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [rows]="rows"
    [name]="name"
    [maxlength]="maxLength"
    class="md-textarea form-control"
    mdbInput
    jhiMarkAsterisk
  ></textarea>
  <textarea
    type="text"
    *ngIf="!placeholder"
    [formControl]="control"
    [id]="id"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [rows]="rows"
    [name]="name"
    [maxlength]="maxLength"
    class="md-textarea form-control"
    mdbInput
    jhiMarkAsterisk
  ></textarea>
  <label [for]="id">{{ label }}</label>
  <small *ngIf="control && control.value" [id]="id + '-help'" class="form-text text-muted">{{ control.value.length }} / {{ maxLength }}</small>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
  </mdb-error>
</div>
